import axiosInstance from "../../api/axiosInstance";

const getCountries = (user) => {
  return new Promise(async (resolve) => {
    try {
      if (!user || !user.profile || !user.locale) {
        return resolve({ codigo: 400, mensaje: "Invalid user data" });
      }

      let countries = Array.isArray(user.locale)
        ? user.locale.join(',')
        : user.locale;

      const uri = `${process.env.REACT_APP_API}/periodo/periodos-pais/countries/all/${encodeURIComponent(countries)}/${encodeURIComponent(user.profile)}`;

      const response = await axiosInstance.get(uri);
      resolve(response.data);

    } catch (error) {
      console.error("Error fetching countries:", error);
      resolve({
        codigo: 500,
        mensaje: "Error fetching countries",
        detalle: error.message
      });
    }
  });
};

export default getCountries;
